import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button } from 'baby-design'
import { CancelReservationActionProps } from './CancelReservationAction.types'

// TODO: implement click handler when cancel reservation modal is implemented
const CancelReservationAction: React.FC<CancelReservationActionProps> = () => (
  <Button
    data-testid="GiftDetails__GiftActions__CancelReservation"
    size="md"
    variant="destructive"
  >
    Cancel reservation
  </Button>
)

export default CancelReservationAction
